<template>
    <div>
        <div v-if="!!vehicleEntries && vehicleEntries.data.length === 0">
            <b-alert show variant="info">No hay vehículos visitantes</b-alert>
        </div>
        <div v-else>
            <b-row v-if="!!vehicleEntries">
                <b-col class="d-flex justify-content-center">
                    <app-paginator
                        v-bind="paginatorProps"
                        @change-page="changePage"
                    />
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" v-if="!!vehicleEntries">
                    <app-vehicle-departure-card
                        v-for="entry in vehicleEntries.data"
                        :key="entry.id"
                        :entry="entry"
                        @departured="onDeparture"
                    ></app-vehicle-departure-card>
                </b-col>
            </b-row>
            <b-row v-if="!!vehicleEntries">
                <b-col class="d-flex justify-content-center">
                    <app-paginator
                        v-bind="paginatorProps"
                        @change-page="changePage"
                    />
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
import appVehicleDepartureCard from './VehicleDepartureCardV2'
import appPaginator from '../../../../UI/Controls/Paginator/PaginatorV2'
export default {
    components: {
        appVehicleDepartureCard,
        appPaginator,
    },
    data: () => ({
        page: 1,
        vehicleEntries: null,
        filters: {},
    }),
    computed: {
        paginatorProps() {
            if (!this.vehicleEntries) return {}
            return _.pick(this.vehicleEntries, [
                'current_page',
                'from',
                'to',
                'total',
                'per_page',
                'last_page',
            ])
        },
    },
    methods: {
        async loadVehicleEntries(filters = {}) {
            if (!!Object.keys(filters).length) {
                const f = { ...this.filters, ...filters }
                this.filters = _.pickBy(f, (val, key) => !!val)
                this.page = 1
            }
            const params = {
                ...this.filters,
                venueId: this.accessPoint.venue_id,
                page: this.page,
                status: 'open',
            }
            const { data } = await repo.get('vehicle-entries', params)
            this.vehicleEntries = data
        },
        changePage(page) {
            this.page = page
            this.loadVehicleEntries()
        },
        clearFilters() {
            this.page = 1
            this.filters = {}
            this.loadVehicleEntries()
        },
        onDeparture(params) {
            this.loadVehicleEntries()
            if (params.withPassengers) this.$emit('passengers-out')
        },
    },
    mounted() {
        this.loadVehicleEntries()
    },
}
</script>
